<template>
  <div>
    <CompanyInfoField
      :label="$t($ts.invoiceSettings.dueDate.title)"
      :description="$t($ts.invoiceSettings.dueDate.description)"
    >
      <v-text-field
        v-model="dueDateLength"
        solo
        :label="'30 ' + $t($ts.generalBookingSettings.days)"
        type="number"
        @blur="saveChanges('dueDateLength', dueDateLength)"
      />
    </CompanyInfoField>

    <v-divider />

    <CompanyInfoField
      :label="$t($ts.invoiceSettings.tax.title)"
      :description="$t($ts.invoiceSettings.tax.description)"
    >
      <v-text-field
        v-model="taxPercentage"
        solo
        type="number"
        @blur="saveChanges('taxPercentage', taxPercentage)"
      />
    </CompanyInfoField>

    <v-divider />

    <CompanyInfoField
      :label="$t($ts.invoiceSettings.taxNumber.title)"
      :description="$t($ts.invoiceSettings.taxNumber.description)"
    >
      <v-text-field
        v-model="taxNumber"
        solo
        @blur="saveChanges('organizationNumber', taxNumber)"
      />
    </CompanyInfoField>

    <CompanyInfoField
      :label="$t($ts.invoiceSettings.bankAccount.title)"
      :description="$t($ts.invoiceSettings.bankAccount.description)"
    >
      <v-text-field
        v-model="bankAccount"
        solo
        @blur="saveChanges('bankAccount', bankAccount)"
      />
    </CompanyInfoField>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Action } from "vuex-class";
import CompanyInfoField from "@/components/global/CompanyInfoField.vue";
import { IUserDTO } from "@shared/types";
import { userModule } from "@/store/modules/user/userModule";
import { dialogModule } from "@/store/modules/dialogModule/dialogModule";

@Component({
  components: {
    CompanyInfoField,
  },
})
export default class GeneralSettings extends Vue {
  @Prop({ required: true }) user!: IUserDTO;

  dueDateLength: number = 30;
  taxPercentage: number = 25;
  taxNumber: string = "";
  bankAccount: string = "";

  created() {
    this.dueDateLength = this.user.dueDateLength;
    this.taxPercentage = this.user.taxPercentage;
    this.taxNumber = this.user.organizationNumber || "";
    this.bankAccount = this.user.bankAccount || "";
  }

  async saveChanges(field: string, value: any) {
    const payload: Partial<IUserDTO> = {
      [field]: value,
    };
    await userModule.updateUser(payload);
    dialogModule.addToDialogQueue({
      text: this.$t(this.$ts.messages.updated).toString(),
    });
  }
}
</script>

<style lang="scss" scoped>
@use "@/styles/global" as *;
</style>
